// extracted by mini-css-extract-plugin
export default {"page":"Guide_page__toou6","content":"Guide_content__EW+ek"};